import React, { useState } from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import ReportsTable from '../../../components/tables/ReportsTable';

const ReportsTopUpHistory = () => {
  const navigate = useNavigate();

  const generateSampleData = (count = 80) => {
    const statuses = ['Submitted', 'Approved', 'Rejected'];
    const actions = ['Finance Lead', 'Settlement Desk', 'Ops Manager'];
    const distributors = Array.from({ length: 20 }, (_, index) => ({
      code: `DIS${String(index + 1).padStart(4, '0')}`,
      name: `Distributor ${index + 1}`,
    }));

    return Array.from({ length: count }, (_, index) => {
      const distributor = distributors[Math.floor(Math.random() * distributors.length)];
      const requestDate = new Date(
        2025,
        Math.floor(Math.random() * 10),
        Math.floor(Math.random() * 28) + 1
      );
      const actionDate = new Date(requestDate);
      actionDate.setDate(actionDate.getDate() + Math.floor(Math.random() * 4));
      const status = statuses[Math.floor(Math.random() * statuses.length)];
      const retailers = Math.floor(Math.random() * 150) + 20;

      return {
        requestId: `SDH${String(index + 1).padStart(6, '0')}`,
        requestDate: requestDate.toISOString().split('T')[0],
        actionDate: actionDate.toISOString().split('T')[0],
        distributorCode: distributor.code,
        distributorName: distributor.name,
        retailerCount: retailers,
        amount: [25000, 45000, 50000, 76000, 82000, 91000, 120000, 150000][
          Math.floor(Math.random() * 8)
        ],
        mode: ['NEFT', 'RTGS', 'IMPS', 'UPI'][Math.floor(Math.random() * 4)],
        status,
        actionBy: status === 'Submitted' ? '-' : actions[Math.floor(Math.random() * actions.length)],
        remarks:
          status === 'Rejected'
            ? ['Supporting documents pending', 'UTR mismatch', 'Exceeded credit limit'][
                Math.floor(Math.random() * 3)
              ]
            : status === 'Approved'
            ? ['Fund released to main wallet', 'Verified and credited', 'Approved with priority'][
                Math.floor(Math.random() * 3)
              ]
            : 'Awaiting review',
      };
    });
  };

  const [data] = useState(generateSampleData(90));

  const columns = [
    { key: 'status', label: 'Status' },
    { key: 'requestId', label: 'Request ID' },
    { key: 'requestDate', label: 'Request Date' },
    { key: 'actionDate', label: 'Action Date' },
    { key: 'distributorCode', label: 'Distributor Code' },
    { key: 'distributorName', label: 'Distributor Name' },
    { key: 'retailerCount', label: 'Retailers Mapped' },
    { key: 'amount', label: 'Amount (₹)' },
    { key: 'mode', label: 'Mode' },
    { key: 'actionBy', label: 'Action By' },
    { key: 'remarks', label: 'Remarks' },
  ];

  return (
    <Container fluid>
      <div className="mb-3">
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={() => navigate('/top-up-request/from-retailer')}
          style={{
            padding: '0.5rem 1rem',
            fontSize: '0.875rem',
            fontWeight: '500',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            width: 'fit-content',
          }}
        >
          <i className="bi bi-arrow-left"></i> Back
        </Button>
      </div>

      <ReportsTable
        data={data}
        reportType="SuperDistributor_TopUpHistory"
        columns={columns}
        title="Top-Up Request History"
      />
    </Container>
  );
};

export default ReportsTopUpHistory;

